// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4959 ? "81720d4b" : chunkId) + "." + {"2602":"78c54653e1afc259","4959":"592a665fd61a7bb5","7361":"cbc47082a754da2f"}[chunkId] + ".js";
};